export const toApiImageFormat = image =>
  image
    ? {
        src: image.src,
        image_id: image.imageId,
        link_url: image.linkUrl,
        size: image.size,
        size_preset: image.sizePreset,
      }
    : undefined;

export const toAppImageFormat = image =>
  image && {
    src: image.src,
    imageId: image.image_id,
    linkUrl: image.link_url,
    sizePreset: image.size_preset,
    size: image.size,
  };
